import { render } from "./NavigationModal.vue?vue&type=template&id=003602c1"
import script from "./NavigationModal.vue?vue&type=script&lang=ts"
export * from "./NavigationModal.vue?vue&type=script&lang=ts"
script.render = render

export default script